/* src/app/components/footer/footer.component.css */
.custom-footer {
  background-color: #EB0029;
  min-height: 105px;
  padding: 31px 54px 22px 54px;
}
.footer-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.footer-links {
  font-family: "Gotham Book";
  font-size: 13px;
  font-style: normal;
  line-height: 18px;
  margin-bottom: 12px;
}
.footer-link {
  color: white;
  text-decoration: none;
}
.separator {
  margin: 0px 10px;
}
.footer-copy {
  font-family: "Gotham Book";
  font-size: 13px;
  font-style: normal;
  line-height: 18px;
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/footer.component.css.map */
